import { Pipe, PipeTransform } from '@angular/core';
import * as momentTz from 'moment-timezone';

@Pipe({
  name: 'locTz',
  standalone: true,
})
export class LocTzPipe implements PipeTransform {
  public timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;


  // @ts-ignore
  transform(time, format?): any {
    if (this.timezone) {
      return momentTz
        .utc(time)
        .tz(this.timezone)
        .format(format ? format : 'HH:mm');
    }
  }
}
